import { Theme } from '@radix-ui/themes';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider, useTheme } from '@/components/ThemeProvider';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { Layout } from '@/components/Layout';
import { Home } from '@/pages/Home';
import { AreaDetail } from '@/pages/AreaDetail';

function AppContent() {
  const { theme } = useTheme();

  return (
    <Theme appearance={theme} accentColor="blue" grayColor="slate" radius="medium">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/:area/:dateOrType" element={<AreaDetail />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </Theme>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <ErrorBoundary>
        <AppContent />
      </ErrorBoundary>
    </ThemeProvider>
  );
}
